import PropTypes from 'prop-types';
import React, {Component} from 'react';

import {Power2, TweenLite} from "gsap";
import ReactDOM from 'react-dom'

import {TransitionGroup} from 'react-transition-group'

class ToggleSelectionContent extends Component {

    static propTypes = {
        id: PropTypes.string,
        keyActiveBefore: PropTypes.string
    }

    constructor(props) {
        super(props)
        this.state = {
            isAnimating: false
        }
    }

    componentWillEnter(callback) {

        let animationInDelay = 0.1

        if (this.props.id === this.props.keyActiveBefore || this.props.keyActiveBefore === "") {
            animationInDelay = 0
        }

        const dom = ReactDOM.findDOMNode(this)
        TweenLite.set(dom, {clearProps: "all"});
        TweenLite.from(dom, 0.3, {
            delay: animationInDelay, ease: Power2.easeInOut, opacity: 0, onComplete: () => {
                this.setState({
                    isAnimating: false
                })
                TweenLite.set(dom, {clearProps: "all"});
                callback()
            }
        })
        this.setState({
            isAnimating: true
        })
    }

    componentWillLeave(callback) {
        const dom = ReactDOM.findDOMNode(this)
        TweenLite.set(dom, {clearProps: "all"});
        this.setState({
            isAnimating: true
        })
        TweenLite.to(dom, 0, {
            ease: Power2.easeInOut, opacity: 0, height: 0, onComplete: () => {
                this.setState({
                    isAnimating: false
                })
                TweenLite.set(dom, {clearProps: "all"});
                callback()
            }
        })
    }

    componentWillUnmount() {
        const dom = ReactDOM.findDOMNode(this)
        TweenLite.killTweensOf(dom)
        TweenLite.set(dom, {clearProps: "all"});
    }

    render() {

        const activeContent = React.Children.map(this.props.children,
            (child) => {

                if (!child) {
                    return null;
                }

                return React.cloneElement(child, {
                    className: this.state.isAnimating ? 'animating' : ''
                })
            }
        )

        return activeContent.length > 0 ? activeContent[0] : null
    }

}

class ToggleSelectionContents extends Component {

    static propTypes = {
        activeKey: PropTypes.string
    }

    constructor(props) {
        super(props)
        this.state = {
            latestActiveKey: ""
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.props !== nextProps) {
            return true
        }
        return false
    }

    componentDidMount() {

        this.componentDidUpdate()

    }

    componentDidUpdate() {

        let activeContents = React.Children.map(this.props.children,
            (child) => {
                if (child && child.key === this.props.activeKey) {
                    return child
                } else {
                    return null
                }
            }
        )

        if (activeContents && activeContents.length !== 0) {
            this.setState({latestActiveKey: this.props.activeKey})
        } else {
            this.setState({latestActiveKey: ""})
        }

    }

    render() {

        let activeContents = React.Children.map(this.props.children,
            (child) => {
                if (child && child.key === this.props.activeKey) {
                    return child
                } else {
                    return null
                }
            }
        )

        if (activeContents && activeContents.length !== 0) {
            activeContents = <ToggleSelectionContent key={this.props.activeKey} id={this.props.activeKey} keyActiveBefore={this.state.latestActiveKey}>{activeContents}</ToggleSelectionContent>
        }

        return (
            <TransitionGroup
                component="div"
                className="toggle-selection__contents">
                {activeContents}
            </TransitionGroup>
        )
    }
}


export default ToggleSelectionContents


/** WEBPACK FOOTER **
 ** ./src/containers/util/ToggleSelectionContents.js
 **/